// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileUserRegister_backIcon__kZMEf","regiBtn":"AdminMobileUserRegister_regiBtn__e3PVY"};